import React, { useEffect, useState } from 'react';
import { IElement, ITextAttributes, ITextSelectionInformation } from '@routes/private/Editor/types';
import { IProps } from './types';
import { findElementById } from '@utils/editor';
import { getFirstLineHeightMove, getTextSelectionInformation, textElementToHtmlTags, htmlTagsToTextElement, getHtmlElementFromEditText, getLastLineHeightMove, restoreSelection, removeSelection } from '@utils/textMultiStyling'
import HtmlTagRendering from 'components/HtmlTagRendering'
import { IHtmlTagDefinition } from 'components/HtmlTagRendering/types'
import { heightOnEmpty, getHtmlFromTexElement } from 'utils/textMultiStyling'
import { getPartIndex } from 'utils/textMultiStyling'

const TextEditAddIn: React.FC<IProps> = (props) => {

    const {
      editorStatus,
      data,
      onCommandChange,
      onSelectedElementIsEditing,
      onSelectedText,
    } = props;

    const [htmlEditElementDefinitions, setHtmlEditElementDefinitions] = useState<IHtmlTagDefinition[]>();
    const [firstLineHeightMove, setFirstLineHeightMove] = useState<number>(0);
    const [lastLineHeightMove, setLastLineHeightMove] = useState<number>(0);
    const [width, setWidth] = useState<number|undefined>();
    const [selectedElement, setSelectedElement] = useState<IElement|undefined>();
     
    
    useEffect(() => {
      if (editorStatus.editElementId) {
        const element = findElementById(data, editorStatus.editElementId);

        setSelectedElement(element);
        if (element)
        {
          const moveTop = getFirstLineHeightMove(element.attributes, (element.attributes as ITextAttributes).partsForRendering); 
          setFirstLineHeightMove(moveTop);
          const movebottom = getLastLineHeightMove(element.attributes, (element.attributes as ITextAttributes).partsForRendering); 
          setLastLineHeightMove(movebottom);
        }
      }
      else {
        setSelectedElement(undefined);
      }
    }, [editorStatus.editElementId, editorStatus.selectedElementsId, data]);
        
    useEffect(() => {
      if (selectedElement && selectedElement.type==="Text" && (selectedElement.attributes as ITextAttributes).width)
      {
        if (width!=(selectedElement.attributes as ITextAttributes).width) {
          setWidth((selectedElement.attributes as ITextAttributes).width);
        }
      }
    }, [editorStatus.editElementId, selectedElement, data]);
    
    useEffect(() => {
    if (editorStatus.editElementId && editorStatus.selectedElementsId.includes(editorStatus.editElementId))
      {
        const element = findElementById(data, editorStatus.editElementId);
        if (element && element.type==="Text") {
          const html: IHtmlTagDefinition[] = textElementToHtmlTags(element?.attributes as ITextAttributes);
          setHtmlEditElementDefinitions(html);
        }
      }
    }, [editorStatus.editElementId, editorStatus.selectedElementIsEditing, width]);

    const borderWidth = 2;
    const cornerSquareWidth = 8;
    const cornersX1 = ((selectedElement?.attributes.x??0) - (cornerSquareWidth/2) - borderWidth);
    const cornersX2 = ((selectedElement?.attributes.x??0) + selectedElement?.attributes.width + borderWidth - (cornerSquareWidth/2));
    const cornersY1 = ((selectedElement?.attributes.y??0) - (firstLineHeightMove) - (cornerSquareWidth/2) - borderWidth);
    const cornersY2 = ((selectedElement?.attributes.y??0) + lastLineHeightMove + selectedElement?.attributes.height + borderWidth - (cornerSquareWidth/2));
    return (
      <>
        {
          
          editorStatus.selectedElementIsEditing && selectedElement && editorStatus.selectedElementsId.includes(editorStatus.editElementId ?? "") && (          
            <>
            <span
              style={{              
              position: 'absolute',
              top: cornersY1 +  'px',
              left: cornersX1 +  'px',
              width: cornerSquareWidth + 'px',
              height: cornerSquareWidth + 'px',
              backgroundColor: '#00A1FF',
              transformOrigin : 'left top',
              transform: 'rotateZ(' + selectedElement?.attributes.rotation + 'deg)',
            }}
            />
            <span
              style={{              
              position: 'absolute',
              top: cornersY1 +  'px',
              left:  cornersX2 +  'px',
              width: cornerSquareWidth + 'px',
              height: cornerSquareWidth + 'px',
              backgroundColor: '#00A1FF',
              transformOrigin : '-' + selectedElement?.attributes.width + 'px 0px',
              transform: 'rotateZ(' + selectedElement?.attributes.rotation + 'deg)',
            }}
            />
            <span
              style={{              
              position: 'absolute',
              top: cornersY2 +  'px',
              left: cornersX1 +  'px',
              width: cornerSquareWidth + 'px',
              height: cornerSquareWidth + 'px',
              backgroundColor: '#00A1FF',
              transformOrigin : '0px ' + '-' + (selectedElement?.attributes.height).toString() + 'px',
              transform: 'rotateZ(' + selectedElement?.attributes.rotation + 'deg)',
            }}
            />
            <span
              style={{              
              position: 'absolute',
              top: cornersY2 +  'px',
              left: cornersX2 +  'px',
              width: cornerSquareWidth + 'px',
              height: cornerSquareWidth + 'px',
              backgroundColor: '#00A1FF',
              transformOrigin : '-' + selectedElement?.attributes.width + 'px ' + '-' + (selectedElement?.attributes.height).toString() + 'px',
              transform: 'rotateZ(' + selectedElement?.attributes.rotation + 'deg)',
            }}
            />
            <span
              style={{              
              position: 'absolute',
              top: ((selectedElement?.attributes.y??0) - (firstLineHeightMove) - borderWidth).toString() +  'px',
              left: ((selectedElement?.attributes.x??0) - borderWidth) +  'px',
              width:selectedElement?.attributes.width + 'px',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
              border: borderWidth + 'px dashed #00A1FF',
              paddingBottom : '0px',
              overflow : 'hidden',              
              outline : 'none',
              resize : 'none',
              transformOrigin : 'top left',
              transform: 'rotateZ(' + selectedElement?.attributes.rotation + 'deg)',
              fontSize: '0px',
              lineHeight: '0',
            }}
            >
            <div
              style={{              
              width:selectedElement?.attributes.width + 'px',
              padding : '0px',
              margin : '0px',
              overflow : 'hidden',              
              outline : 'none',
              resize : 'none',
              transformOrigin : 'left top',
              textAlign : (selectedElement?.attributes as ITextAttributes).textAlign as 'center' | 'right' | 'left',
              whiteSpace:'pre-line',
              display: 'inline-block',
              wordBreak: 'break-word',
              fontSize: '0px',
              lineHeight: '0',
              minHeight:  (selectedElement.attributes as  ITextAttributes).style.fontSize??heightOnEmpty
            }}
            id={'editorTextEditAddIn'}
            contentEditable 
            onFocus={(e)=>{
            }} 
            onKeyUp={(e)=>{
              let sp = e.target as HTMLSpanElement
              const lastAttributes = selectedElement?.attributes as ITextAttributes;
              if ((sp.textContent??"")!==(lastAttributes.text??"")) {
                let cursorposition: number|undefined = undefined;
                const textSelectionInformation: ITextSelectionInformation|undefined = getTextSelectionInformation();
                cursorposition = textSelectionInformation?.start;
                const newTextAttributes = htmlTagsToTextElement(lastAttributes, sp.textContent??"", cursorposition);
                onCommandChange("text",newTextAttributes);
                if (newTextAttributes?.text.trim() === "") {
                  const editElement = getHtmlElementFromEditText();
                  if (editElement && newTextAttributes && e.key !== 'Enter') {
                    const html = getHtmlFromTexElement(newTextAttributes);
                    editElement.innerHTML = html; 
                    restoreSelection(editElement, 0, 1);
                  }
                }
              }
            }}
            onKeyDown={(e)=>{
            }}
            onPaste={(e) => {
              const text = e.clipboardData.getData('text').replaceAll('\r','');
              let attributes = selectedElement?.attributes as ITextAttributes;
              const lastFirstPartStyle = attributes.parts.length>0?attributes.parts[0].style:{};
              const textSelectionInformation: ITextSelectionInformation|undefined = getTextSelectionInformation();
              const initSelection = textSelectionInformation?.start??0;
              const lengthSelection = textSelectionInformation?.length??0;
              attributes = removeSelection(attributes, initSelection, lengthSelection);
              if (attributes.parts.length === 0) {
                attributes.parts.push({length:0, style:{...lastFirstPartStyle}});
              }
              const partIntex = getPartIndex(attributes.parts, initSelection);
              const oldText = attributes.text;
              const newText = oldText.substring(0,initSelection) + text + oldText.substring(initSelection);
              attributes.text = newText;
              attributes.parts[partIntex].length += text.length;
              onCommandChange("text",attributes);
              const html: IHtmlTagDefinition[] = textElementToHtmlTags(attributes as ITextAttributes);
              setHtmlEditElementDefinitions(html);
              onSelectedElementIsEditing(undefined,false);
              e.preventDefault(); 
              const rootKeyboard = document.getElementById("rootKeyboard");
              if (rootKeyboard) rootKeyboard.focus()
              return false;
            }}
            onSelect={(e)=>{
              const textSelectionInformation: ITextSelectionInformation|undefined = getTextSelectionInformation();
              if (textSelectionInformation) onSelectedText(textSelectionInformation);
            }}
            onDragEnter={(event)=> {event.preventDefault(); event.dataTransfer.dropEffect = 'none'; return false}}
            onDragLeave={(event) => {event.preventDefault(); return false}}
            onDragOver={(event) => {event.preventDefault(); event.dataTransfer.dropEffect = 'none'}}
            onDrop={(event) => {event.preventDefault(); return false}}
            >
              {
                htmlEditElementDefinitions &&
                <>
                {
                  htmlEditElementDefinitions.map((htmlEditElementDefinition: IHtmlTagDefinition) => {
                    return (
                      <HtmlTagRendering tagDefinition={htmlEditElementDefinition}/>
                    );
                  })
                } 
                </>             
              }
            </div>         
          </span>
          </>
          )
        }
      </>
    );
  }
  
  export default TextEditAddIn;